export default {
      id: "USD-usage",
      viewBox: "0 0 8.5 16.4",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#USD",
      toString: function () {
        return this.url;
      }
    }